import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function BetaWarningBanner() {
  const [isDismissed, setIsDismissed] = React.useState(() => {
    return localStorage.getItem('whipt_beta_warning_dismissed') === 'true';
  });

  const handleDismiss = () => {
    localStorage.setItem('whipt_beta_warning_dismissed', 'true');
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <div className="sticky top-0 left-0 right-0 z-[40] bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white px-4 py-3 shadow-2xl border-b-4 border-amber-600">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center animate-pulse">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div>
            <p className="font-bold text-sm md:text-base">⚠️ Beta Testing Phase</p>
            <p className="text-xs md:text-sm text-amber-100">
              WHIPT is currently in beta. You may experience bugs or changes. Report issues via the Suggestion Box!
            </p>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 px-3 py-1 text-xs font-bold bg-white/20 hover:bg-white/30 rounded-full transition-colors"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
